import { AdsPage } from "./AdsPage";
import { AdPage } from "./AdPage";
import { AdsFaqPage } from "./AdsFaqPage";

const pages = {
  AdsPage,
  AdPage,
  AdsFaqPage,
};
export default pages;
